/** SUNTRONIX ONE — StatusPill (ONE VIBE).
 *  Accessible semantic status pill.  Colour is always paired with the label
 *  text, never colour alone.
 */
import { pillClass } from "@/lib/vibe";

export function StatusPill({ status, label, className = "", testid }) {
  const text = label || String(status || "").replace(/_/g, " ");
  return (
    <span
      data-testid={testid || `status-pill-${String(status || "").toLowerCase()}`}
      className={
        "inline-flex items-center gap-1.5 h-6 px-2.5 rounded-full border text-[11px] font-semibold " +
        "uppercase tracking-[0.04em] " + pillClass(status) + " " + className
      }
    >
      <span className="inline-block h-1.5 w-1.5 rounded-full bg-current opacity-70" />
      {text}
    </span>
  );
}

export default StatusPill;
